import type { LoggerContext, LoggerInterface } from '@/utils/logging/_types';

export enum LogLevel {
  error,
  debug,
  info,
}

export function DevLogger(logLevel: LogLevel): LoggerInterface {
  const info = (message: string, context?: LoggerContext) => {
    if (logLevel < LogLevel.info) return;
    if (context) {
      console.info('[INFO]', message, context);
      return;
    }
    console.info('[INFO]', message);
  };

  const debug = (message: string, context?: LoggerContext) => {
    if (logLevel < LogLevel.debug) return;
    if (context) {
      console.log('[DEBUG]', message, context);
      return;
    }
    console.log('[DEBUG]', message);
  };

  const warn = (message: string, context?: LoggerContext) => {
    if (context) {
      console.warn('[WARN]', message, context);
      return;
    }
    console.warn('[WARN]', message);
  };

  const error = (message: string, context?: LoggerContext) => {
    if (context) {
      console.info('[ERROR]', message, context);
      return;
    }
    console.info('[ERROR]', message);
  };

  return Object.freeze({
    info,
    debug,
    warn,
    error,
  });
}
